import apiClient from 'apiClient';
import { BrokerDetailsDataMapper, SupportProfileDataMapper } from './mapper';

export const fetchBrokerDetails = async () => {
  const { data } = await apiClient.get('/api/v1/broker-management/adviser-supports-and-profile');
  return BrokerDetailsDataMapper.map(data);
};

export const fetchSupportProfileDetails = async () => {
  const { data } = await apiClient.get('/api/v1/broker-management/user-profile');
  return SupportProfileDataMapper.map(data);
};
